import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { ModalContainer, ShimmerWrapper } from "./loadingFullPageModalStyling";

interface LoadingFullPageProps {
    guestMode: boolean;
    reverse?: boolean;
}

const LoadingFullPage: React.FC<LoadingFullPageProps> = ({ guestMode, reverse }) => {
    useEffect(() => {
        document.body.style.overflow = "hidden";
        document.body.style.position = "relative";
        document.body.style.height = "100vh";
        document.documentElement.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "unset";
            document.body.style.position = "unset";
            document.body.style.height = "unset";
            document.documentElement.style.overflow = "unset";
        };
    }, []);
    return (
        <ModalContainer>
            <ShimmerWrapper>
                <img 
                    src="https://d292awxalydr86.cloudfront.net/Branding/Anystay.svg"
                    alt="Anystay Logo"
                    style={{
                        height: '32px',
                        width: 'auto'
                    }}
                />
            </ShimmerWrapper>
        </ModalContainer>
    );
};

const LoadingFullPageModal: React.FC<LoadingFullPageProps> = ({ guestMode, reverse }) => {
    return createPortal(<LoadingFullPage guestMode={guestMode} reverse={reverse} />, document.getElementById("root") as HTMLElement);
};

export default LoadingFullPageModal;
